// src/utils/TooltipPortal.js
import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';

// Create a portal container for tooltips
let tooltipRoot = null;

const getTooltipRoot = () => {
  if (!tooltipRoot) {
    tooltipRoot = document.createElement('div');
    tooltipRoot.id = 'tooltip-root';
    tooltipRoot.style.position = 'fixed';
    tooltipRoot.style.top = '0';
    tooltipRoot.style.left = '0';
    tooltipRoot.style.width = '100%';
    tooltipRoot.style.height = '100%';
    tooltipRoot.style.pointerEvents = 'none';
    tooltipRoot.style.zIndex = '100001';
    // Ensure it doesn't interfere with mobile scrolling
    tooltipRoot.style.touchAction = 'none';
    tooltipRoot.style.userSelect = 'none';
    tooltipRoot.style.webkitUserSelect = 'none';
    tooltipRoot.style.webkitTouchCallout = 'none';
    tooltipRoot.style.webkitTapHighlightColor = 'transparent';
    // Make sure it doesn't block any interactions
    tooltipRoot.setAttribute('aria-hidden', 'true');
    document.body.appendChild(tooltipRoot);
  }
  return tooltipRoot;
};

const TooltipPortal = ({ children, isVisible }) => {
  const [portalRoot, setPortalRoot] = useState(null);

  useEffect(() => {
    setPortalRoot(getTooltipRoot());
  }, []);

  if (!portalRoot || !isVisible) {
    return null;
  }

  return createPortal(children, portalRoot);
};

export default TooltipPortal; 